const checkStateData = (obj, keyOrKeyArray, defaultValue) => {
    const keyArray = typeof keyOrKeyArray === 'string' ? [keyOrKeyArray] : keyOrKeyArray
    const keyArrayLength = keyArray.length - 1

    const checkObj = (object, index) => {
        const key = keyArray[index];

        if(object.hasOwnProperty(key)) {
            if(index == keyArrayLength) {
                return object[key]
            } else {
                return checkObj(object[key], index + 1)
            }
        } else  {
            return defaultValue
        }
    }

    if(obj) {
        return checkObj(obj, 0)

    } else {
        return defaultValue
    }
}

export default checkStateData